import React, { useState, useEffect, useRef } from "react";
import { Link } from 'react-scroll';

export default function NavBar() {
  const [sticky, setSticky] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > (window.innerHeight - ref.current.clientHeight));
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { to: "home", label: "Home" },
    { to: "about", label: "About" },
    { to: "services", label: "Services" },
    { to: "contact", label: "Contact" },
  ];

  return (
    <div ref={ref} style={sticky ? styles.navSticky : styles.nav}>
      {/* Desktop nav */}
      <div className="hidden sm:flex w-4/12 mx-auto justify-between">
        {navLinks.map(({ to, label }) => (
          <div key={to}>
            <Link to={to} smooth={true} offset={-75}>
              <button className="p-3" onClick={() => setMenuOpen(false)}>
                <span className="text-primary uppercase text-xs">{label}</span>
              </button>
            </Link>
          </div>
        ))}
      </div>

      {/* Mobile hamburger */}
      <div className="sm:hidden w-full flex justify-center relative">
        <button
          className="p-3 text-primary"
          onClick={() => setMenuOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          <div className="flex flex-col gap-1.5">
            <span className={`block w-6 h-0.5 bg-current transition-transform ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
            <span className={`block w-6 h-0.5 bg-current transition-opacity ${menuOpen ? 'opacity-0' : ''}`} />
            <span className={`block w-6 h-0.5 bg-current transition-transform ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
          </div>
        </button>

        {/* Dropdown */}
        {menuOpen && (
          <div className="absolute top-full left-0 w-full bg-white shadow-md flex flex-col items-center z-50">
            {navLinks.map(({ to, label }) => (
              <Link key={to} to={to} smooth={true} offset={-75}>
                <button className="py-3 px-6 w-full" onClick={() => setMenuOpen(false)}>
                  <span className="text-primary uppercase text-xs">{label}</span>
                </button>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

let styles = {
  nav: {
    backgroundColor: 'white',
    position: 'absolute',
    bottom: 0,
    width: '100%',
    height: '80px',
    textAlign: 'center',
    fontFamily: "Montserrat",
    zIndex: 10,
    display: 'flex',
    alignItems: 'center',
  },
  navSticky: {
    backgroundColor: 'white',
    width: '100%',
    height: '80px',
    textAlign: 'center',
    fontFamily: "Montserrat",
    position: 'fixed',
    top: 0,
    zIndex: 20,
    display: 'flex',
    alignItems: 'center',
  }
};